export { default as Footer } from './Footer';
export { getFooterSlices, getVariation } from './Footer.components';
